class ScrollProgress extends HTMLElement {
  constructor() {
    super();
    this.checkScroll = this.checkScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.retryFrame = null;
    this.initialized = false;
  }

  connectedCallback() {
    const observes = this.getAttribute('observes');
    if (!observes) return;
    this.observes = observes;

    this.scroller = document.getElementById(this.observes);
    if (this.scroller) {
      this.init();
    } else {
      // Retry if element not yet available
      this.retryFrame = requestAnimationFrame(() => {
        this.retryFrame = null;
        this.scroller = document.getElementById(observes);
        if (this.scroller) this.init();
      });
    }
  }

  init() {
    if (!this.scroller || this.initialized) return;
    this.initialized = true;
    this.scroller.addEventListener('scroll', this.checkScroll, { passive: true });
    // The observer reports the scroller once as soon as it is laid out, which sets the first value. Measuring here
    // as well made every bar force a layout of its freshly inserted rail, one after another, in a single long frame.
    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(this.scroller);
  }

  disconnectedCallback() {
    if (this.retryFrame) cancelAnimationFrame(this.retryFrame);
    this.retryFrame = null;
    if (this.scroller) {
      this.scroller.removeEventListener('scroll', this.checkScroll);
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    this.initialized = false;
  }

  checkScroll() {
    if (!this.scroller) return;
    
    const { scrollLeft, scrollWidth, clientWidth } = this.scroller;
    const maxScroll = scrollWidth - clientWidth;
    
    if (maxScroll <= 0) {
      this.style.setProperty('--scroll-progress', '0');
      return;
    }

    const progress = Math.max(0, Math.min(1, scrollLeft / maxScroll));
    this.style.setProperty('--scroll-progress', progress.toString());
  }

  handleResize() {
    this.checkScroll();
  }
}

if (!customElements.get('scroll-progress')) {
  customElements.define('scroll-progress', ScrollProgress);
}
